import React from 'react';
import styled from '@emotion/styled';

export const ButtonComponent = (props) => {
  const { values } = props;
  return (
    <ButtonContainer>
      <SubmitButton type='submit' disabled={!values.isFormReady}>
        회원가입
      </SubmitButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.article`
  margin: 50px 0;
  /* background-color: aqua; */
`;

const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  border: 2px solid #002366;
  background-color: #ffffff;
  border-radius: 10px;
  font-size: 25px;
  font-weight: bold;
  color: #002366;
  :disabled {
    border: 2px solid #c4c4c4;
    color: #c4c4c4;
  }
  @media only screen and (max-width: 992px) {
    font-size: 20px;
  }
`;
